import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HoldProcessingFailureDialogComponent } from './hold-processing-failure-dialog.component';
import { SharedModule } from '../../shared.module';
import { FlexModule } from '@angular/flex-layout';

@NgModule({
  declarations: [HoldProcessingFailureDialogComponent],
  imports: [CommonModule, SharedModule, FlexModule],
})
export class HoldProcessingFailureDialogModule {}
